export enum SmartphoneSalePages {
  Form,
  Evaluation,
}
